'use strict';

const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');let

HelpCenterConfig=class HelpCenterConfig{
static get $inject(){return['$stateProvider']}

constructor($stateProvider){
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('helpCenter');
$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=HelpCenterConfig;
//# sourceMappingURL=helpCenterConfig.js.map
